import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useField } from 'formik';
import { FC } from 'react';

export const FormikDateField: FC<{ name: string; label: string }> = props => {
  const [, meta, helpers] = useField<string | undefined | null>(props.name);

  const handleChange = (newValue: Date | null) => {
    if (newValue && newValue instanceof Date && !isNaN(newValue as any)) {
      helpers.setValue(newValue.toISOString());
    }
  };

  return (
    <DesktopDatePicker
      label="Datum"
      format="dd.MM.yyyy"
      value={meta.value ? new Date(meta.value) : null}
      onChange={handleChange}
      slotProps={{
        textField: {
          fullWidth: true,
          error: Boolean(meta.touched) && Boolean(meta.error),
          helperText: meta.error || '',
        },
      }}
    />
  );
};
